















































import {Component, Vue} from 'vue-property-decorator';
import {traineesClient, worksheetsClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";
import TimestablesSelect from "@/components/math/timestables.select.vue";
import {StartTimesTablesRequest} from "@/domain/worksheets/StartTimesTablesRequest";
import {MathWorksheetState, PostAnswerModel, StartAutoTimesTablesRequestModel} from "@/api/api.clients";
import LearnMathTask from "@/components/math/learn.math.task.vue";
import NumberInput from "@/components/NumberInput.vue";
import EventBus from "@/components/event-bus";

@Component({
    components: {
        NumberInput,
        TimestablesSelect,
        LearnMathTask
    }
})

export default class learnMathTimestables extends Vue {
    private busy: boolean = true;
    private id: string = '';
    private profile: TraineeProfileModel | null = null;
    private topic: string | null = null;
    public selectedTables: number[] = [];
    private wksState: MathWorksheetState | null = null;
    public solution: string = '';
    public attempt: number = 1;
    private hasError: boolean = false;
    private lastAnswer: string | null = null;


    public start: number = 0;

    async mounted() {
        this.id = this.$route.params.id;
        this.profile = await traineesClient.getProfile(this.id);
        this.topic = this.$route.query.topic as string;
        this.busy = false;
    }


    get task() {
        if (this.wksState && this.wksState.nextTask)
            return this.wksState.nextTask.task;
        else
            return null;
    }

    private setNewState(state: MathWorksheetState) {

        this.wksState = state;
        this.attempt = 1;
        this.start = performance.now()
    }

    private async completeWorksheet() {

        if (this.wksState?.worksheetId) {

            EventBus.$emit("refresh.coins");
            await worksheetsClient.complete(this.wksState.worksheetId.value);
            await this.$router.push({name: "traineeLearningComplete"});
        }
    }

    private async checkSolution() {

        this.lastAnswer = this.task?.displayValue + '=' + this.solution;
        const duration: number = Number((performance.now() - this.start).toFixed(0));

        console.log(duration);

        if (!this.busy && this.solution && this.solution.length > 0) {
            this.busy = true;
            const maxAttempt: number = this.wksState?.maxAttemptsPerItem ?? 2;
            const val = parseInt(this.solution);

            const wasAnswerCorrect = this.wksState?.nextTask.task.result == val;

            if (!wasAnswerCorrect) {
                this.hasError = true;
            }
            const request: PostAnswerModel = {
                itemId: this.wksState?.nextTask.id.value ?? '',
                task: this.task?.displayValue ?? '',
                traineeId: this.profile?.id ?? '',
                wasCorrect: wasAnswerCorrect,
                numberOfAttempts: this.attempt,
                duration: duration
            };

            if (wasAnswerCorrect || this.attempt > maxAttempt) {
                const response = await worksheetsClient.postAnswer(this.wksState?.worksheetId.value ?? '', request);

                this.hasError = false;

                if (response.nextTask) {
                    this.setNewState(response);
                    console.log(response)
                    this.$forceUpdate();
                } else {
                    await this.completeWorksheet();
                }

            } else {
                this.attempt++;
            }

            this.clearSolution();


            if (this.wksState == null || this.wksState?.plannedTasks.length < 1) {
                await this.completeWorksheet();
            }
        }

        this.busy = false;
    }


    private clearSolution() {

        this.solution = '';
    }

    private numberClicked(val: number) {
        this.solution = this.solution + val;
    }

    private async timesTablesAutoSelected() {
        this.busy = true;


        const tables: number[] = [2, 3, 4, 5, 6, 7, 8, 9];
        this.selectedTables = tables;

        const model: StartAutoTimesTablesRequestModel = {traineeId: this.id};
        const state = await worksheetsClient.startAutomatedTimesTables(model);

        this.busy = false;
        this.setNewState(state);
        this.$forceUpdate();
    }

    private async timesTableSelected(tables: number[]) {
        console.log(tables);
        this.selectedTables = tables;

        const model = new StartTimesTablesRequest(this.selectedTables, this.id);
        this.busy = true;
        const state: MathWorksheetState = await worksheetsClient.startTimesTables(model);
        this.busy = false;

        this.setNewState(state);
        this.$forceUpdate();

    }
}
